import { Skeleton } from '@/components/ui/skeleton'
import { useProjects } from '../hooks/useProjects'
import { FilmCard } from '../components/FilmCard'

export function ProjectsPage() {
  const { projects, loading, error } = useProjects()

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-16">
        <Skeleton className="mb-4 h-10 w-48" />
        <Skeleton className="mb-8 h-5 w-80" />
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="space-y-3">
              <Skeleton className="aspect-video w-full rounded-lg" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-full" />
            </div>
          ))}
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-16">
        <p className="text-destructive text-sm">{error}</p>
      </div>
    )
  }

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="mb-10 max-w-2xl">
        <h1 className="mb-3 text-4xl font-bold tracking-tight">Projects</h1>
        <p className="text-muted-foreground leading-relaxed">
          Client work, collaborations, and one-off films created outside of our flagship series.
        </p>
      </div>

      {projects.length === 0 ? (
        <p className="text-muted-foreground text-sm">No projects published yet.</p>
      ) : (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {projects.map((project) => (
            <FilmCard key={project.id} film={project} />
          ))}
        </div>
      )}
    </div>
  )
}
